import { Namespace, useT } from "@racoon/i18n";

/**
 * Card header: record name over its entity type. Shared by the navigation and
 * single-open entry points so the two can't drift apart. Sizes are set here
 * because the surrounding ModalHeader/ModalTitle default to `text-lg`.
 */
export const CardHeading = ({ name }: { name: string }) => {
  const t = useT();
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-base font-bold leading-tight text-text-primary">{name}</span>
      <span className="text-[10px] font-medium uppercase leading-tight tracking-wide text-text-secondary">
        {t(Namespace.Table, "organizaation")}
      </span>
    </div>
  );
};
